import { PolarProductTypes } from "./PolarProductTypes";

export interface PolarProductConfig {
    productType: PolarProductTypes,
    productCategory: ProductCategoryTypes;
    productName: string;
    kioskTypes: KioskTypes[];
}

export enum ProductCategoryTypes {
    PhotoSticker = "PhotoSticker",
    PhotoStickerDieCut = "PhotoStickerDieCut",
    PhotoCard = "PhotoCard",
    ColorNames = "ColorNames",
    GraphicNames = "GraphicNames",
    CardCover = "CardCover",
    IpSpecial = "IpSpecial",
    GiftCard = "GiftCard",
    Etc = "Etc",
    CheerUp = "CheerUp"
}

export enum KioskTypes {
    ColorNames = "ColorNames",
    PolaPolar = "PolaPolar",
    StickerMakers = "StickerMakers",
    CardMakers = "CardMakers",
    Igloo = "Igloo",
    CheerUp = "CheerUp"
}

export const productConfigs: PolarProductConfig[] = [
    {
        productType: PolarProductTypes.NameSticker, productCategory: ProductCategoryTypes.Etc, kioskTypes: [KioskTypes.PolaPolar], productName: "네임스티커",
    },
    {
        productType: PolarProductTypes.Classic, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "클래식 포토",
    },
    {
        productType: PolarProductTypes.ClassicNew, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "클래식 뉴",
    },
    {
        productType: PolarProductTypes.Mini, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "미니 포토",
    },
    {
        productType: PolarProductTypes.BoldFrame, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "굵은 프레임",
    },
    {
        productType: PolarProductTypes.NarrowFrame, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "얇은 프레임",
    },
    {
        productType: PolarProductTypes.MiniHalf, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "미니 하프",
    },
    {
        productType: PolarProductTypes.Minime, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "미니미",
    },
    {
        productType: PolarProductTypes.VerticalFrame, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "버티컬 프레임",
    },
    {
        productType: PolarProductTypes.StoryPhoto, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "스토리 포토",
    },
    {
        productType: PolarProductTypes.MyRoutineCalendar, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "마이루틴 캘린더",
    },
    {
        productType: PolarProductTypes.CollaboCalendar, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "콜라보 캘린더",
    },
    {
        productType: PolarProductTypes.SloganSticker2Cut, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.Igloo], productName: "슬로건 스티커 2컷",
    },
    {
        productType: PolarProductTypes.SloganSticker3Cut, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.Igloo], productName: "슬로건 스티커 3컷",
    },
    {
        productType: PolarProductTypes.IglooPhotoBooth, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.Igloo], productName: "이글루 포토부스",
    },

    {
        productType: PolarProductTypes.GraphicNamesticker, productCategory: ProductCategoryTypes.GraphicNames, kioskTypes: [KioskTypes.PolaPolar], productName: "그래픽 네임스티커",
    },
    {
        productType: PolarProductTypes.PhotoNamesticker, productCategory: ProductCategoryTypes.GraphicNames, kioskTypes: [KioskTypes.PolaPolar], productName: "포토 네임스티커",
    },
    {
        productType: PolarProductTypes.GraphicNamesticker12cut, productCategory: ProductCategoryTypes.GraphicNames, kioskTypes: [KioskTypes.PolaPolar], productName: "그래픽 네임스티커 12컷",
    },

    {
        productType: PolarProductTypes.ColornamesOriginal, productCategory: ProductCategoryTypes.ColorNames, kioskTypes: [KioskTypes.ColorNames], productName: "컬러네스 오리지널",
    },
    {
        productType: PolarProductTypes.ColornamesColorful, productCategory: ProductCategoryTypes.ColorNames, kioskTypes: [KioskTypes.ColorNames], productName: "컬러넴스 컬러풀",
    },
    {
        productType: PolarProductTypes.ColornamesPhoto, productCategory: ProductCategoryTypes.ColorNames, kioskTypes: [KioskTypes.ColorNames], productName: "컬러넴스 포토",
    },

    {
        productType: PolarProductTypes.SelfCutSticker, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "셀프컷 스티커",
    },
    {
        productType: PolarProductTypes.PhotoCollageSticker, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "포토 콜라주 스티커",
    },
    {
        productType: PolarProductTypes.PrintingTicket, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "폴라코드",
    },
    {
        productType: PolarProductTypes.FullFrame, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "풀 프레임",
    },
    {
        productType: PolarProductTypes.FullFrame6x8, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "풀 프레임 6x8",
    },
    {
        productType: PolarProductTypes.MultiFrame6x8, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "멀티 프레임 6x8",
    },
    {
        productType: PolarProductTypes.PaperToy, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "페이퍼 토이",
    },

    {
        productType: PolarProductTypes.IdolAteez, productCategory: ProductCategoryTypes.Etc, kioskTypes: [KioskTypes.PolaPolar], productName: "아이돌 에이티즈",
    },

    {
        productType: PolarProductTypes.CardCoverSticker, productCategory: ProductCategoryTypes.CardCover, kioskTypes: [KioskTypes.PolaPolar], productName: "카드 커버 스티커",
    },
    {
        productType: PolarProductTypes.CardCoverStickerDieCut, productCategory: ProductCategoryTypes.CardCover, kioskTypes: [KioskTypes.PolaPolar], productName: "카드 커버 스티커 다이컷",
    },

    {
        productType: PolarProductTypes.IpSpecial, productCategory: ProductCategoryTypes.IpSpecial, kioskTypes: [KioskTypes.PolaPolar], productName: "IP 스페셜",
    },
    {
        productType: PolarProductTypes.IpSecialColornames, productCategory: ProductCategoryTypes.IpSpecial, kioskTypes: [KioskTypes.ColorNames], productName: "IP 스페셜 컬러넴스",
    },
    {
        productType: PolarProductTypes.IpSpecialStickerMaker, productCategory: ProductCategoryTypes.IpSpecial, kioskTypes: [KioskTypes.StickerMakers], productName: "IP 스페셜 스티커 메이커",
    },

    {
        productType: PolarProductTypes.PhotoCard, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.CardMakers], productName: "포토카드",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolis, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolisIp, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis IP",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolisLucky, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis Lucky",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolisId, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis ID",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolisHighTeen, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis HighTeen",
    },
    {
        productType: PolarProductTypes.PhotoCardEvolisIgloo, productCategory: ProductCategoryTypes.PhotoCard, kioskTypes: [KioskTypes.PolaPolar], productName: "포토카드 Evolis Igloo",
    },


    // 스메 전용
    {
        productType: PolarProductTypes.Card, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "카드 스티커",
    },
    {
        productType: PolarProductTypes.Seal, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "씰스티커",
    },
    {
        productType: PolarProductTypes.Phone, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "폰케이스 스티커",
    },
    {
        productType: PolarProductTypes.Griptok, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "그립톡",
    },
    {
        productType: PolarProductTypes.AcrylicStand, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "아크릴 스탠드",
    },
    {
        productType: PolarProductTypes.Plate, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "플레이트",
    },
    {
        productType: PolarProductTypes.AirFreshener, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "에어 프레쉬너",
    },
    {
        productType: PolarProductTypes.WaterGlitter, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "워터 글리터",
    },
    {
        productType: PolarProductTypes.BallPen, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "볼펜",
    },
    {
        productType: PolarProductTypes.Keyring, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "키링",
    },
    {
        productType: PolarProductTypes.KeyringAcryl2cut, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "키링 아크릴 2컷",
    },
    {
        productType: PolarProductTypes.KeyringAcryl4cut, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "키링 아크릴 4컷",
    },
    {
        productType: PolarProductTypes.FreeFormCutPath, productCategory: ProductCategoryTypes.PhotoStickerDieCut, kioskTypes: [KioskTypes.StickerMakers], productName: "프리폼 컷 패스",
    },

    {
        productType: PolarProductTypes.TimeTable, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.PolaPolar], productName: "시간표",
    },
    {
        productType: PolarProductTypes.TemplateFrame, productCategory: ProductCategoryTypes.PhotoSticker, kioskTypes: [KioskTypes.Igloo], productName: "템플릿 프레임",
    },

    {
        productType: PolarProductTypes.DaisoGiftCard5K, productCategory: ProductCategoryTypes.GiftCard, kioskTypes: [KioskTypes.PolaPolar], productName: "다이소 상품권 5천원",
    },
    {
        productType: PolarProductTypes.DaisoGiftCard10K, productCategory: ProductCategoryTypes.GiftCard, kioskTypes: [KioskTypes.PolaPolar], productName: "다이소 상품권 1만원",
    },
    {
        productType: PolarProductTypes.DaisoGiftCard30K, productCategory: ProductCategoryTypes.GiftCard, kioskTypes: [KioskTypes.PolaPolar], productName: "다이소 상품권 3만원",
    },
    {
        productType: PolarProductTypes.DaisoGiftCard50K, productCategory: ProductCategoryTypes.GiftCard, kioskTypes: [KioskTypes.PolaPolar], productName: "다이소 상품권 5만원",
    },
    {
        productType: PolarProductTypes.CheerUpGroupSlogan, productCategory: ProductCategoryTypes.CheerUp, kioskTypes: [KioskTypes.CheerUp], productName: "치얼업 그룹 슬로건",
    },
    {
        productType: PolarProductTypes.CheerUpMemberSlogan, productCategory: ProductCategoryTypes.CheerUp, kioskTypes: [KioskTypes.CheerUp], productName: "치얼업 멤버 슬로건",
    },
    {
        productType: PolarProductTypes.IpSpecialCheerUp, productCategory: ProductCategoryTypes.CheerUp, kioskTypes: [KioskTypes.CheerUp], productName: "IP 스페셜 치얼업",
    },
    {
        productType: PolarProductTypes.CheerUpCustomSlogan, productCategory: ProductCategoryTypes.CheerUp, kioskTypes: [KioskTypes.CheerUp], productName: "치얼업 커스텀 슬로건",
    },
];
